import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BookingEmailTemplate } from '../booking-email-template';
import { CKEDITOREMAILCONFIG } from '../ckeditor-config';
import { HttpService } from '../service/http.service';
import { Language } from '../language';
import { ToastMessageService } from '../toast-message.service';
import * as Editor from '../../libs/ckeditor';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-create-booking-email-template',
  templateUrl: './create-booking-email-template.component.html',
  styleUrls: ['./create-booking-email-template.component.css']
})
export class CreateBookingEmailTemplateComponent implements OnInit {

  templateForm!: FormGroup;
  languages: Language[] = [];
  processing = false;

  emailEditorConfig = CKEDITOREMAILCONFIG;

  public Editor = Editor;
  colors: string[] = environment.backgroundColors;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    this.templateForm = this.builder.group({
      name: [null, Validators.required],
      subject: [null, Validators.required],
      body: [null, Validators.required],
      language: [null, Validators.required],
      backgroundColor: null
    });

    this.httpService.getLanguages().subscribe(res => {
      this.languages = res;
    });
  }

  postTemplate(){
    if(this.templateForm.invalid){
      return;
    }
    this.processing = true;
    let template = new BookingEmailTemplate(
      null,
      this.templateForm.value.name, 
      this.templateForm.value.subject,
      this.templateForm.value.body, 
      this.templateForm.value.language, 
      null, 
      null, 
      this.templateForm.value.backgroundColor
      );

      this.httpService.postBookingEmailTemplate(template).subscribe(() => {
        this.toastService.addSuccess("Success", "Template created");
        this.processing = false;
      }, error => {
        this.toastService.addError("Error", error.message);
        this.processing = false;
      });
  }

  updateBackgroundColor(value: string | null){
    this.templateForm.get("backgroundColor")?.setValue(value);
  }

}
